import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  base: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '0.7em',
    marginBottom: 8
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/label/Label.styles.js